<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
    <modal
      :show.sync="$store.state.account.modals.subscribe"
      class="modal-default"
      :show-close="false"
      headerClasses="justify-content-center"
      style="padding-top: 100px;"
    >
      <p>{{$t('subscribe_desc')}}</p>
      <fg-input v-model="email" placeholder="Email"></fg-input>
      <template slot="footer">
        <n-button type="danger" @click="closeModal('subscribe')">{{$t('CLOSE')}}</n-button>
        <n-button type="success" @click="subscribe()">{{$t('SUBSCRIBE')}}</n-button>
      </template>
    </modal>
    <div
      style="position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; background-color: #00000099; cursor: pointer; z-index: 900;"
      v-if="$store.state.account.modals.wallet"
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="$store.state.account.modals.wallet"
      style="position: fixed; top: calc((100% - 440px) / 2); left: 0px; padding-top: 32px; text-align: center; width: 100%; height: 340px; background-image: url('/img/1st_sale/pop_wallet.png'); background-size: 100% 100%; z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closeModal('wallet')"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <h5 style="color: white; font-size: 24px; font-weight: 900;">{{$t('connect_wallet')}}</h5>
      <h6
        style="position: absolute; top: 100px; color: black; font-size: 18px; font-weight: 500; width: 100%; text-align: center;"
      >{{$t('info_select_wallet')}}</h6>
      <div
        style="position: absolute; top: 140px; left: 39px; width: calc(100% - 78px); height: 180px; display: flex; flex-flow: row wrap; justify-content: space-between;"
      >
        <img
          src="/img/wallet/icon_wallet_5.png"
          width="80"
          height="80"
          style="cursor: pointer;"
          @click="openWallet('tp')"
        />
        <img
          src="/img/wallet/icon_wallet_6.png"
          width="80"
          height="80"
          style="cursor: pointer;"
          @click="openWallet('mykey')"
        />
        <img
          src="/img/wallet/icon_wallet_4.png"
          width="80"
          height="80"
          style="cursor: pointer;"
          @click="openWallet('trust')"
        />
        <img
          src="/img/wallet/icon_wallet_7.png"
          width="80"
          height="80"
          style="cursor: pointer;"
          @click="openWallet('imtoken')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Modal, Button, FormGroupInput } from "@/components";
import config from "./config.js";
import axios from "axios";
import { connectWallet } from "./utils/wallet";
import ga from "./ga";

export default {
  components: {
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  watch: {
    "$store.state.account.modals.wallet": function(val) {
      if (val == true) {
        if (window.web3 != undefined) {
          this.$store.commit("closeModal", "wallet");
          this.connect("metamask");
        }
      }
    }
  },
  data() {
    return {
      email: ""
    };
  },
  mounted: function() {
    if (window.web3 != undefined) {
        this.connect("metamask");
      }
  },
  methods: {
    connect: async function(type) {
      var balance = 0;
      let account = connectWallet(this.$store, type);
      this.closeModal("wallet");
    },
    closeAllPopup() {
      this.closeModal("wallet");
    },
    closeModal: function(modalName) {
      this.$store.commit(`closeModal`, modalName);
    },
    openWallet: function(wallet) {
      let url = ``;
      let redirectUrl = `https://m-land.leagueofkingdoms.com/`;
      let params = '';
      let parameters = JSON.parse(localStorage.parameters);
      if (parameters.utm_source != null || parameters.utm_medium != null || parameters.ref != null) {
        if (parameters.utm_source != null) {
          if (params == '') {
            params += '?';
          }
          else {
            params += '&';
          }
          params += "utm_source=" + parameters.utm_source;
        }
        if (parameters.utm_medium != null) {
          if (params == '') {
            params += '?';
          }
          else {
            params += '&';
          }
          params += "utm_medium=" + parameters.utm_medium;
        }
        if (parameters.ref != null) {
          if (params == '') {
            params += '?';
          }
          else {
            params += '&';
          }
          params += "ref=" + parameters.ref;
        }
      }
      redirectUrl += params;

      switch (wallet) {
        case "tp":
          url = `tpdapp://open?params={"url": "${redirectUrl}", "chain": "ETH", "source":"chrome"}`;
          break;
        case "mykey":
          url = `mykey://mykey.org/dapp?url=${encodeURI(redirectUrl)}`;
          break;
        case "trust":
          url = `https://link.trustwallet.com/open_url?coin_id=60&url=${redirectUrl}`;
          break;
        case "imtoken":
          url = `imtokenv2://navigate/DappView?url=${redirectUrl}`;
          break;
      }
      if (url != "") {
        ga.gaEvent('event', 'connectWallet', {
            'event_label': wallet
        });
        window.location.href = url;
      }
    },
    subscribe: async function() {
      let email = this.email.trim();
      if (email.length < 3) {
        alert(this.$t(`alert_invalid_email`));
        return;
      }
      let device = "";
      if (this.$device.mobile) {
        device = "mobile/";
        if (this.$device.android || this.$device.androidPhone) {
          device += "android";
        } else {
          device += "ios";
        }
      } else {
        device = "pc";
      }
      let parameters = JSON.parse(localStorage.parameters);
      let ret = await axios.post(`${config.api.stat_url}/preregist/subscribe`, {
        email: email,
        utm_source: parameters.utm_source,
        utm_medium: parameters.utm_medium,
        ref: parameters.ref,
        device: device,
        language: navigator.language,
        language2: this.$i18n.locale,
        from: "land"
      });
      if (ret.data.result == false) {
        alert(this.$t(`alert_${ret.data.err.code}`));
      } else {
        alert(this.$t(`subscribe_ok`));
      }
      this.closeModal("subscribe");
    }
  }
};
</script>